<div class="preloader-backdrop" *ngIf="spinner">
  <div class="page-preloader">Loading</div>
</div>
